import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"
import { Global } from "../../classes/global"

export class TextBlock3D {
	static create(
		scene: BABYLON.Scene,
		id: string,
		text: string,
		position: [number, number, number],
		fontSize: number,
		fontWeight: string,
		colour: string,
		grabbable: boolean,
		visibility: boolean,
		size: [number, number],
		parentID?: string // New parameter for parent ID
	): void {
		const plane = BABYLON.MeshBuilder.CreatePlane(
			id,
			{ width: size[0], height: size[1] },
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])
		// Create an advanced texture for this plane
		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(
			plane,
			1024,
			1024
		)

		// Create the text block
		const textBlock = new GUI.TextBlock()
		textBlock.width = "5000px" // Ensure this matches or exceeds your expected text width
		textBlock.height = "5000px"
		textBlock.text = text
		textBlock.fontFamily = "Nunito, sans-serif"
		textBlock.fontSize = fontSize + "px" // Font size in pixels for consistency
		textBlock.fontWeight = fontWeight
		textBlock.color = colour
		// Align text within its container, not stretching it
		textBlock.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT
		textBlock.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP
		textBlock.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT // Align control to left
		textBlock.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP // Align control to top

		// Overflow behavior: text is clipped if it exceeds the container's bounds
		//textBlock.textWrapping = true

		advancedTexture.addControl(textBlock)

		if (parentID) {
			const parentMesh = plane._scene!.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}

		if (grabbable) {
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})

			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}
		plane.isVisible = visibility
		plane.renderingGroupId = 2
		plane.isPickable = false
	}
}
